import { render, staticRenderFns } from "./_loginSelectResellerModal.vue?vue&type=template&id=5f0001ca&scoped=true"
import script from "./_loginSelectResellerModal.vue?vue&type=script&lang=js"
export * from "./_loginSelectResellerModal.vue?vue&type=script&lang=js"
import style0 from "./_loginSelectResellerModal.vue?vue&type=style&index=0&id=5f0001ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0001ca",
  null
  
)

export default component.exports